
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import InternalTicketsRepositoryInterface, { Ticket } from '@/services/Internal-Tickets/interfaces';
import TicketDetailsEditDialog from '@/views/pages/internal-tickets/TicketDetailsEditDialog.vue';


@Component({
  components: { TicketDetailsEditDialog },
  inject: ['internalTicketsRepository'],
})
export default class TicketInfo extends Vue {
  public dialogVisible: boolean = false;
  public showDetails: boolean = true;

  public readonly detailName_Assignee = 'assignee';
  public readonly detailName_Component = 'component';
  public readonly detailName_Priority = 'priority';
  public readonly detailName_Status = 'status';

  @Prop() public ticket: Ticket;
  public detailName: string = '';
  public reporter: string = '';


  toggleDetails() {
    this.showDetails = !this.showDetails;
  }

  public readonly internalTicketsRepository: InternalTicketsRepositoryInterface;


  @Watch('ticket', { immediate: true, deep: true })
  public async onTicketChanged(newTicket: Ticket, oldTicket: Ticket) {
    if (oldTicket && newTicket.reporter !== oldTicket.reporter) {
      await this.setReporter(newTicket.reporter);
    }
  }


  public async setReporter(reporter: string): Promise<void> {
    const data = await this.internalTicketsRepository.getUsersData([reporter]);
    if (data && data.length > 0) {
      this.reporter = data[0].firstName + ' ' + data[0].lastName;
    } else {
      this.reporter = 'Unknown Reporter';
    }
  }

  public edit(object: any, componentType:string) {
    if (componentType === 'assignee') {
      this.detailName = this.detailName_Assignee
    }
    if (componentType === 'component') {
      console.log('its component');
      this.detailName = this.detailName_Component
    }
    if (componentType === 'status') {
      console.log('its status');
      this.detailName = this.detailName_Status
    }
    if (componentType === 'priority') {
      console.log('its priority');
      this.detailName = this.detailName_Priority
    }
    this.dialogVisible = true;
  }

  public cancelDialog() {
    console.log('received from event emitter');
    this.dialogVisible = false;
  }

  public refresh(ticketId: string) {
    this.$emit('refresh', ticketId);
    this.dialogVisible = false;
  }
}

